import { Vue, Component, Prop } from 'vue-property-decorator';

import ApprenticeResponse from '../../models/responses/ApprenticeResponse';

/**
 * Apprentice Card to display an Apprentice with Name and Picture
 *
 * @param apprentice - a single apprentice
 */
@Component({
  name: 'ApprenticeCard',
})
export default class ApprenticeCard extends Vue {
  @Prop(Object) private readonly apprentice: ApprenticeResponse | undefined;
}
